export interface DataState<T> {
  data: T | null,
  error: string,
  status: LoadingStatus
}

export enum LoadingStatus {
  Loading,
  Success,
  Failed
}

